<form [formGroup]="dateControlForm">
  <div class="flexCenterAlign">
    <mat-form-field class="yearOfLastEntry w-p-90">
      <input
        matInput
        readonly
        [matDatepickerFilter]="disableFutureDate"
        [placeholder]="tag.TagKey"
        [matDatepicker]="picker"
        formControlName="yearControl"
        [disabled]="disabled"
        [attr.id]="buildElementId('fld-year')"
      />
      <div class="calender-icon">
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"
          [disabled]="disabled"
          [attr.id]="buildElementId('btn-datepicker-toggle')"
        >
          <img
            matDatepickerToggleIcon
            src="./assets/images/application-logos/svg/ic-calendar.svg"
          />
        </mat-datepicker-toggle>
        <mat-datepicker
          #picker
          (yearSelected)="calenderSelected($event, picker)"
          (viewChanged)="viewChanged(picker)"
          startView="multi-year"
        >
        </mat-datepicker>
      </div>
    </mat-form-field>
    <button
      type="button"
      mat-icon-button
      color="accent"
      (click)="clearContent()"
      [disabled]="disabled"
      [attr.id]="buildElementId('btn-clear-year')"
    >
      <i
        class="icon-ic-remove-doc pointCursor"
        [class.disabled-clear-icon]="disabled"
        matTooltipClass="tooltip-style"
        matTooltipPosition="above"
        matTooltip="Remove tag"
      >
      </i>
    </button>
  </div>
</form>
